import React from "react";
import { ArrowUpRight } from "lucide-react";
import { fr } from "@/locales/fr";
import { appUrl } from "@/lib/referral";

const APP_SIGNUP = "https://work.voxiumscript.com";

export const PrimaryCardsFR = () => {
  return (
    <section
      className="bg-cream w-full px-6 sm:px-10 lg:px-16 pb-28 sm:pb-32 lg:pb-40"
      data-testid="primary-cards-section-fr"
    >
      <div className="max-w-[78rem] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-8 xl:gap-12">
        {fr.cards.map((card) => (
          <article
            key={card.testId}
            className="group relative flex flex-col h-full bg-cream border-t border-cream-200 pt-10 lg:pt-12"
            data-testid={card.testId}
          >
            <div className="flex items-baseline gap-4 mb-8">
              <span
                className="display-serif text-gold text-3xl leading-none"
                aria-hidden="true"
              >
                {card.mark}
              </span>
              <span className="eyebrow text-nearblack/70">{card.eyebrow}</span>
            </div>

            <h3 className="display-serif text-nearblack text-2xl sm:text-[1.75rem] leading-[1.15] mb-6">
              {card.headline}
            </h3>

            {Array.isArray(card.body) ? (
              card.body.map((para, i) => (
                <p
                  key={i}
                  className="font-body text-base leading-relaxed text-nearblack/80 mb-4 last:mb-6"
                >
                  {para}
                </p>
              ))
            ) : (
              <p className="font-body text-base leading-relaxed text-nearblack/80 mb-6">
                {card.body}
              </p>
            )}

            <p className="font-body italic text-sm text-nearblack/70 mb-8 max-w-[30ch]">
              Idéal pour&nbsp;: {card.bestFor}
            </p>

            <div className="mt-auto pt-2">
              <a
                href={appUrl(APP_SIGNUP, { lang: "fr" })}
                className="inline-flex items-center gap-2 font-ui text-sm text-nearblack border-b border-nearblack/30 pb-1 tap-extend transition-colors duration-200 hover:text-gold-600 hover:border-gold"
                data-testid={`${card.testId}-cta`}
              >
                {card.cta}
                <ArrowUpRight size={14} strokeWidth={2} className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default PrimaryCardsFR;
